module.exports = __webpack_public_path__ + "img/pic01.8e9429be.jpg";